import BankVoucherFormPage from "./BankVoucherFormPage";

export default function ReceiptVoucherPage() {
  return <BankVoucherFormPage voucherType="RECEIPT" title="Receipt Voucher" subtitle="Record money received into Cash or a Bank Account." />;
}
